// Import model
import { PasswordFieldOptions } from '../models/PasswordFieldOptions';

// Import base class serializer
import { FieldOptionsSerializer } from './FieldOptionsSerializer';

// Import dependency types (models and enums used in properties)

// Import dependency serializers (for complex types)

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for PasswordFieldOptions - handles JSON serialization and deserialization with type validation
 */
export class PasswordFieldOptionsSerializer {
  /**
   * Deserializes a JSON string into a PasswordFieldOptions instance
   */
  static deserialize(json: string): PasswordFieldOptions {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a PasswordFieldOptions instance
   */
  static fromObject(obj: any): PasswordFieldOptions {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to PasswordFieldOptions');
    }


    const instance: PasswordFieldOptions = {
      t: obj['_t'] as string,
      linkUrl: obj['LinkUrl'] as string | undefined,
      linkLabel: obj['LinkLabel'] as string | undefined,
      _46D9Ea55: obj['_46d9ea55'] as any | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of PasswordFieldOptions instances
   */
  static deserializeArray(json: string): PasswordFieldOptions[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a PasswordFieldOptions instance to a JSON string
   */
  static serialize(instance: PasswordFieldOptions): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a PasswordFieldOptions instance to a plain object
   */
  static toObject(instance: PasswordFieldOptions): any {
    return {
      '_t': instance.t,
      'LinkUrl': instance.linkUrl,
      'LinkLabel': instance.linkLabel,
      '_46d9ea55': instance._46D9Ea55,
    };
  }

  /**
   * Serializes an array of PasswordFieldOptions instances to a JSON string
   */
  static serializeArray(instances: PasswordFieldOptions[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
